<template>
  <div class="text-center">
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="dialog"
      max-width="1030"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-row align="center" justify="space-around" class="my-n30">
          <v-btn
            v-bind="attrs"
            v-on="on"
            text
            color="primary"
            class="ma-1"
            outlined
          >
            VER SUSTITUTOS TECNICOS
          </v-btn>
        </v-row>
      </template>

      <v-card>
        <v-card-title class="text-h5 primary white--text">
          Sustitutos Técnicos
        </v-card-title>

        <v-card-text class="prueba">
          <v-sheet max-width="1000">
            <v-slide-group active-class="success" show-arrows center-active>
              <v-slide-item
                v-for="(product, i) in products.slice(0, 19)"
                :key="i"
              >
                <cardProduct
                  class="ml-1 mt-2 mb-5 mr-1"
                  v-bind:product="product"
                  :sendSnack="sendSnack"
                >
                </cardProduct>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn color="primary" text @click="dialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import cardProduct from "./../product/child_cardProduct.vue";
export default {
  name: "child_similarProduct",

  components: {
    cardProduct,
  },

  data() {
    return {
      dialog: true,
      title: "",
    };
  },

  props: {
    products: { type: Array },
    similar: { type: Boolean },
    sendSnack: { type: Function },
  },

  methods: {},

  computed: {},

  watch: {},

  created: function () {},

  mounted() {},
};
</script>

<style>
.prueba {
  font-size: 0.95rem;
  margin: 5px 0;
  line-height: 14px;
}
</style>
